import React, { useEffect, useMemo, useRef, useState } from "react";
import RoomTypesTable from "./Components/RoomTypesTable";
import SidebarForm from "../../../../../Common/CommonSidebarForm";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_AMENITY_REQUEST,
  GET_ROOM_TYPE_REQUEST,
  PATCH_ROOM_TYPE_REQUEST,
  POST_ROOM_TYPE_REQUEST,
  RESET_ROOM_TYPE_FLAGS,
} from "../../../../../Utils/Constant";
import { hasAddAccess } from "../../../../../Common/CheckAccess";

const RoomTypes = () => {
  const sidebarRef = useRef();
  const dispatch = useDispatch();
  const [selectedRoom, setSelectedRoom] = useState(null);
  const { allAmenities, loading } = useSelector((state) => state.amenity);
  const roomTypeCreated = useSelector(
    (state) => state.roomType.roomTypeCreated
  );
  const roomTypeUpdated = useSelector(
    (state) => state.roomType.roomTypeUpdated
  );
  const [shouldRefresh, setShouldRefresh] = useState(false);

  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  const initialValues = {
    room_type: "",
    price: 0,
    capacity: "",
    bed_count: "",
    bed_type: "",
    amenities: [],
    room_size: "",
    extra_bed: "",
    description: "",
    number_of_room: "",
  };

  // useEffect(() => {
  //   dispatch({ type: GET_AMENITY_REQUEST });
  // }, [dispatch]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (['admin', 'super_admin', 'manager', 'front_desk'].includes(role)) {
      dispatch({ type: GET_AMENITY_REQUEST });
    }
  }, [dispatch]);
  
  
  useEffect(() => {
    if (roomTypeCreated) {
      setShouldRefresh((prev) => !prev);
      sidebarRef.current?.closeSidebar();
      dispatch({ type: RESET_ROOM_TYPE_FLAGS });
    }
    if (roomTypeUpdated) {
      setShouldRefresh((prev) => !prev);
      sidebarRef.current?.closeSidebar();
      dispatch({ type: RESET_ROOM_TYPE_FLAGS });
    }
  }, [roomTypeCreated, roomTypeUpdated, dispatch]);

  const amenityOptions = useMemo(() => {
    if (!allAmenities?.data?.data) return [];
    return allAmenities?.data?.data?.map((amenity) => ({
      label: amenity.amenity_name,
      value: amenity.id.toString(),
    }));
  }, [allAmenities]);

  const roomTypeFields = useMemo(
    () => [
      { name: "room_type", label: "Room Type", type: "text", required: true },
      { name: "price", label: "Room Price", type: "number", required: true },
      {
        name: "number_of_room",
        label: "Number of Room",
        type: "number",
        required: true,
      },
      { name: "capacity", label: "Capacity", type: "number", required: true },
      {
        name: "bed_count",
        label: "Bed Count",
        type: "number",
        required: false,
      },
      { name: "bed_type", label: "Bed Type", type: "text", required: false },
      {
        name: "amenities",
        label: "Amenities",
        type: "multiselect",
        required: false,
        options: amenityOptions,
      },
      {
        name: "room_size",
        label: "Room Size",
        type: "number",
        required: false,
      },
      {
        name: "extra_bed",
        label: "Extra Bed",
        type: "number",
        required: false,
      },
      {
        name: "description",
        label: "Description",
        type: "text",
        required: false,
      },
    ],
    [amenityOptions]
  );

  const onsubmit = (data, isEdit = false) => {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (key !== "amenities") {
        formData.append(key, data[key]);
      }
    });

    if (data.amenities && data.amenities.length > 0) {
      data.amenities.forEach((amenityId) => {
        formData.append("amenities[]", amenityId);
      });
    } else {
      formData.append("amenities[]", "");
    }

    // Add hotel_id from localStorage
    const hotelId = localStorage.getItem('hotel_id');
    if (hotelId) {
      formData.append('hotel_id', hotelId);
    }

    if (isEdit && data.id) {
      dispatch({
        type: PATCH_ROOM_TYPE_REQUEST,
        payload: { id: data.id, data: formData },
      });
    } else {
      dispatch({ type: POST_ROOM_TYPE_REQUEST, payload: formData });
    }
  };

  return (
    <>
      <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
          <div className="col-sm-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h3 className="fw-bold mb-0">Room Types</h3>
              <div className="col-auto d-flex w-sm-100">
                {hasAddAccess(permissions, "rooms") && (
                  <button
                    type="button"
                    className="btn btn-dark"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#add-room"
                    aria-controls="add-room"
                    onClick={() => setSelectedRoom(null)}
                  >
                    Add Room Type
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-body ">
                <RoomTypesTable
                  shouldRefresh={shouldRefresh}
                  setShouldRefresh={setShouldRefresh}
                  setSelectedRoom={setSelectedRoom}
                  selectedRoom={selectedRoom}
                  selectedItem
                  sidebarRef={sidebarRef}
                  isLoading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SidebarForm
        ref={sidebarRef}
        id="add-room"
        title={selectedRoom === null ? "Add Room Type" : "Edit Room Type"}
        initialValues={initialValues}
        fields={roomTypeFields}
        onSubmit={onsubmit}
        selectedItem={selectedRoom}
        permission="rooms"
      />
    </>
  );
};

export default RoomTypes;
